import { render, staticRenderFns } from "./GenderFilter.vue?vue&type=template&id=8903da36&scoped=true&"
import script from "./GenderFilter.vue?vue&type=script&lang=js&"
export * from "./GenderFilter.vue?vue&type=script&lang=js&"
import style0 from "./GenderFilter.vue?vue&type=style&index=0&id=8903da36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8903da36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
installComponents(component, {VChip})
